import { render, staticRenderFns } from "./InfoNotification.vue?vue&type=template&id=5bfd63d5&lang=pug"
import script from "./InfoNotification.vue?vue&type=script&lang=js"
export * from "./InfoNotification.vue?vue&type=script&lang=js"
import style0 from "./InfoNotification.vue?vue&type=style&index=0&id=5bfd63d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports